<c-card *transloco="let t">
  <c-card-body class="px-2">
    <c-row>
      <c-col class="col-lg-6 col-12">
        <h1>{{ t('Alert Zone Intelligence') }}</h1>
      </c-col>
      <c-col class="col-lg-6 col-12 text-end justify-content-end">
        <div class="btn-group mb-2" role="group">
          <button class="btn btn-info text-white mb-2" type="button" routerLink="/mgmt/threats/notifications">
            <i class="fa-solid fa-bell"></i> {{ t('View Notifications') }}
          </button>
          <button class="btn btn-success text-white mb-2" type="button" routerLink="/mgmt/threats/new">
            <i class="fa-solid fa-plus"></i> {{ t('Create Alert Zone') }}
          </button>
        </div>
      </c-col>
    </c-row>

    <c-row>
      <c-col class="col-12">
        <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('threat_intelligence_info')">
          <i class="fa-solid fa-circle-info"></i> {{ t('Alert Zone Intelligence lets you define custom geographic threat areas for your organisation. Workers can receive alerts when they enter or approach these areas.') }}
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('threat_intelligence_info')"></button>
        </div>
      </c-col>
    </c-row>

    <form cForm class="row g-2 align-items-end mb-3" [formGroup]="formGroup" (ngSubmit)="updateFilter()">
      <c-col class="col-12 col-lg-3">
        <c-input-group>
          <span cInputGroupText><svg cIcon name="cil-search"></svg></span>
          <input cFormControl formControlName="search" placeholder="{{ t('Search') }}" />
        </c-input-group>
      </c-col>
      <c-col class="col-6 col-lg-2">
        <select cSelect formControlName="severity" (change)="updateFilter()">
          <option value="">{{ t('All Severities') }}</option>
          <option *ngFor="let sev of meta.severities" [value]="sev">{{ sev }}</option>
        </select>
      </c-col>
      <c-col class="col-6 col-lg-2">
        <select cSelect formControlName="active" (change)="updateFilter()">
          <option value="1">{{ t('Active Only') }}</option>
          <option value="0">{{ t('Inactive Only') }}</option>
          <option value="">{{ t('All Statuses') }}</option>
        </select>
      </c-col>
      <c-col class="col-auto">
        <button cButton class="btn btn-light me-2" type="submit"><i class="fa-solid fa-magnifying-glass"></i> {{ t('Search') }}</button>
        <button cButton class="btn btn-light text-danger" type="button" (click)="cancelSearch()" *ngIf="formGroup.value.search">
          <i class="fa-solid fa-circle-xmark"></i>
        </button>
      </c-col>
      <c-col class="col-12 col-lg-3 text-lg-end" *ngIf="pagination.totalPages > 1">
        <c-input-group>
          <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
          <select cSelect name="page" [(ngModel)]="pagination.page" [ngModelOptions]="{standalone: true}" (change)="changePage()">
            <option *ngFor="let p of pagination.pageArray" [value]="p">{{ p }}</option>
          </select>
        </c-input-group>
      </c-col>
      <c-col class="col-12 col-lg-2 text-lg-end">
        <c-input-group>
          <span cInputGroupText><svg cIcon name="cil-sort-ascending"></svg></span>
          <select cSelect [(ngModel)]="sort" [ngModelOptions]="{standalone: true}" (change)="updateFilter()">
            <option value="newest">{{ t('Newest') }}</option>
            <option value="oldest">{{ t('Oldest') }}</option>
            <option value="severity">{{ t('Severity') }}</option>
            <option value="event">{{ t('Event') }}</option>
          </select>
        </c-input-group>
      </c-col>
    </form>

    <c-row *ngIf="threats">
      <c-col>
        <table [hover]="true" [responsive]="true" [striped]="true" align="middle" cTable class="mb-0 border">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">{{ t('Event') }}</th>
              <th scope="col">{{ t('Headline') }}</th>
              <th scope="col">{{ t('Severity') }}</th>
              <th scope="col">{{ t('Area') }}</th>
              <th scope="col">{{ t('Description') }}</th>
              <th scope="col">{{ t('Status') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let threat of threats">
              <td class="text-nowrap">
                <button cButton color="info" class="btn-sm text-white" [routerLink]="['/mgmt/threats', threat.id, 'edit']" *ngIf="threat.active">
                  <i class="fa-solid fa-pen-to-square"></i> {{ t('Edit') }}
                </button>
              </td>
              <td><b>{{ threat.event }}</b></td>
              <td>{{ threat.headline }}</td>
              <td>
                <span class="badge" [ngStyle]="severityBadgeStyle(threat.severity)">{{ threat.severity }}</span>
              </td>
              <td>{{ threat.area_desc }}</td>
              <td>{{ threat.description }}</td>
              <td>
                <span class="badge bg-success" *ngIf="threat.active">{{ t('Active') }}</span>
                <span class="badge bg-secondary" *ngIf="!threat.active">{{ t('Inactive') }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="text-muted mt-3" *ngIf="threats.length === 0">{{ t('No alert zone intelligence records found.') }}</p>
      </c-col>
    </c-row>
  </c-card-body>
</c-card>
